import CaseyShort from '@assets/icons/casey-short.svg';
import i18n from '@/utils/i18n';
import React from 'react';
import { AnimationView } from '@usepepper/ui/atoms/animation-view';
import { createStyles } from '@/contexts/theme-context';
import { StyleProp, View, ViewStyle } from 'react-native';

const thinkingLoader = require('@assets/lottie/thinking_loader.json');

export interface Props {
  containerStyle?: StyleProp<ViewStyle>;
  isLoading: boolean;
}

const DIAMETER = 32;
const LOADER_SIZE = 48;

export const CaseyAvatar: React.FC<Props> = ({ containerStyle, isLoading }) => {
  const [styles] = useStyles();

  return (
    <View>
      <View style={[styles.avatar, containerStyle]}>
        <CaseyShort accessibilityLabel={i18n.t('casey_ai.avatar.title')} />
      </View>
      {isLoading && (
        <View
          accessibilityLabel={i18n.t('casey_ai.avatar.loading')}
          style={styles.lottieContainer}
        >
          <AnimationView
            source={thinkingLoader}
            style={styles.loadingAnimation}
          />
        </View>
      )}
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  avatar: {
    alignItems: 'center',
    backgroundColor: theme.colors.transparent,
    borderRadius: DIAMETER,
    height: DIAMETER,
    justifyContent: 'center',
    width: DIAMETER,
  },
  loadingAnimation: {
    height: LOADER_SIZE,
    width: LOADER_SIZE,
  },
  lottieContainer: {
    alignItems: 'center',
    height: LOADER_SIZE,
    justifyContent: 'center',
    width: LOADER_SIZE,
  },
}));
